export default 'https://tme.understood.org/assets/background.ee74cfd7.glb'